import convertHexToRGBA from '@/utils/convertHexToRGBA'
export default {
  computed: {
    boxLogin() {
      const loginParams = this.objectLoginParams.login
      const defaultUrl = `${window.location.origin}/e/media/login/Login-Logo.png`
      const labelsDefaultForm = {
        user: 'Usuario',
        pass: 'Contraseña'
      }
      return {
        logoUrl: loginParams.box.logo.url
          ? loginParams.box.logo.url
          : defaultUrl,
        sizeLogo: loginParams.box.logo.size,
        styles: {
          box: {
            borderRadius: loginParams.box.borderRadius,
            backgroundColor: convertHexToRGBA(
              loginParams.box.bgColor,
              loginParams.box.transparent
            ),
            borderTop: loginParams.box.borderTop,
            borderTopColor: loginParams.box.borderTop
              ? loginParams.box.borderTopColor
              : '',
            borderTopStyle: loginParams.box.borderTop ? 'solid' : ''
          },
          shadow: loginParams.box.boxShadow //detail in document lg, md, xl with values
            ? `shadow-${loginParams.box.boxShadow}`
            : 'shadow-md',
          form: {
            inputs: {
              bgColor: {
                backgroundColor: convertHexToRGBA(
                  loginParams.form.inputs.bgColor,
                  loginParams.form.inputs.transparent
                )
              },
              outlineColor: loginParams.form.inputs.outlineColor
                ? loginParams.form.inputs.outlineColor.substring(1)
                : 'primary'
            },
            textColor: {
              color: loginParams.form.textColor
            },
            buttons: {
              bgColor: {
                backgroundColor: loginParams.form.buttons.bgColor
              }
            },
            buttonSSO: {
              showButton: loginParams.form.hasOwnProperty('buttonSSO')
                ? loginParams.form.buttonSSO.showButton
                : ''
            }
          },
          commerceInfo: {
            textColor: {
              color: loginParams.commerceInfo.textColor
            },
            bgColor: {
              backgroundColor: loginParams.commerceInfo.bgColor
            },
            showButtons: loginParams.commerceInfo.showButtons
          }
        },
        textLabels: {
          user: loginParams.form.labels.userName
            ? loginParams.form.labels.userName
            : labelsDefaultForm.user,
          pass: loginParams.form.labels.userPass
            ? loginParams.form.labels.userPass
            : labelsDefaultForm.pass
        }
      }
    }
  }
}
